import { FunctionComponent } from 'react'
import { Box, Typography, rucksack } from '@black-bear-energy/rucksack'
import {
  enableChecklistCategories,
  enableSideNavigation,
} from '../../featureFlags'
import { ReleaseNotes } from './ReleaseNotes'

export const Dashboard: FunctionComponent = () => {
  if (!(enableSideNavigation && enableChecklistCategories)) {
    return null
  }

  return (
    <Box>
      <Typography variant="h4" color={rucksack.palette.text.primary}>
        Welcome to the Black Bear Energy Forager Platform!
      </Typography>
      <Box
        sx={{
          border: '0.5px solid',
          borderColor: rucksack.palette.primary.outlinedBorder,
          borderRadius: rucksack.shape.borderRadius,
          backgroundColor: rucksack.palette.background.card,
          padding: 3,
          marginTop: 2,
        }}
      >
        <ReleaseNotes />
      </Box>
    </Box>
  )
}
